// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {toast} from '@wandb/weave/common/components/elements/Toast';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
// @todo: Migrate to 'DropdownMenu' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import copy from 'copy-to-clipboard';
import React, {memo, useState} from 'react';

import {envIsLocal} from '../../../config';
import {
  MemberData,
  TeamBaseEntity,
  TeamOrganization,
} from '../../../graphql/teamQuery';
import DeleteMemberModal from '../../DeleteMemberModal';
import {copyTokenLink} from '../OrgDashboardMembersTable/utils';
import {InviteKey} from './utils';

type TeamMemberActionMenuProps = {
  member: MemberData;
  organization?: TeamOrganization;
  entity: TeamBaseEntity;
  refetch?: () => void;
  isViewerAdmin: boolean;
  getIsMemberCurrentViewer: boolean;
  inviteKey: InviteKey;
};

const TeamMemberActionMenuComp = ({
  member,
  organization,
  entity,
  refetch,
  isViewerAdmin,
  getIsMemberCurrentViewer,
  inviteKey,
}: TeamMemberActionMenuProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [isDeleteMemberModalOpen, setIsDeleteMemberModalOpen] = useState(false);

  let isDeletableByViewer = false;
  let isInviteCreatedByViewer = false;
  if (member.pending && member.email) {
    if (inviteKey?.wasCreatedByViewer) {
      isInviteCreatedByViewer = true;
    }
  }
  if ((isViewerAdmin && !getIsMemberCurrentViewer) || isInviteCreatedByViewer) {
    isDeletableByViewer = true;
  }

  if (!isViewerAdmin && !isDeletableByViewer) {
    return null;
  }

  return (
    <DropdownMenu.Root open={isMenuOpen} onOpenChange={setIsMenuOpen}>
      <DropdownMenu.Trigger>
        <Button
          variant="ghost"
          icon="overflow-horizontal"
          active={isMenuOpen}
        />
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content align="end">
          <>
            {isDeletableByViewer && (
              <DropdownMenu.Item
                onClick={() => setIsDeleteMemberModalOpen(true)}>
                <Icon name="delete" />
                Remove user
              </DropdownMenu.Item>
            )}

            {isViewerAdmin && envIsLocal && (
              <DropdownMenu.Item
                onClick={getInviteURL({
                  admin: isViewerAdmin,
                  member,
                  entity,
                  inviteKey,
                })}>
                <Icon name="copy" />
                Copy invite
              </DropdownMenu.Item>
            )}
          </>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>

      {isDeleteMemberModalOpen && (
        <DeleteMemberModal
          member={member}
          org={organization}
          entityName={entity?.name}
          refetch={refetch}
          onClose={() => setIsDeleteMemberModalOpen(false)}
        />
      )}
    </DropdownMenu.Root>
  );
};

const getInviteURL: ({
  admin,
  member,
  entity,
  inviteKey,
}: {
  admin: boolean;
  member: MemberData;
  entity: TeamBaseEntity;
  inviteKey: InviteKey;
}) => () => Promise<void> = ({admin, member, entity, inviteKey}) => {
  const email = member?.email;

  const copyInviteUrl = async () => {
    const inviteUrl = document.location.origin;

    // If user is a team admin and has no invite key then
    // they are the team creator
    if (member?.admin && !inviteKey) {
      toast('User is team creator');
      return;
    }

    // If user has a username and an invite key, then they
    // have already created their account and can use the
    // team invite link
    if (member?.username && inviteKey) {
      copy(
        `${inviteUrl}/${entity?.name}?invited=${inviteKey.name}&newUser=false`
      );
      toast('Team invite link copied to clipboard');
      return;
    }

    if (!admin) {
      toast(
        'User has not created their account yet - please contact admin for signup link'
      );
      return;
    }

    try {
      await copyTokenLink(email, '/signup');
      toast('Invite link copied to clipboard');
    } catch (err) {
      toast('Error retrieving invite link');
      return;
    }
  };

  return copyInviteUrl;
};

export const TeamMemberActionMenu = memo(TeamMemberActionMenuComp);
